module.exports = __webpack_public_path__ + "static/media/imagem-plano-terms.2a26e9a6.png";